const envConfig = process.env || {};

export const environment = {
  host: envConfig.REACT_APP_HOST,
};

export const amplifyConfig = {
  authenticationFlowType: envConfig?.REACT_APP_AWS_AMPLIFY_CUSTOM_AUTH,
  Auth: {
    mandatorySignIn: true,
    region: envConfig?.REACT_APP_AWS_AMPLIFY_REGION,
    userPoolId: envConfig?.REACT_APP_AWS_AMPLIFY_USER_POOL_ID,
    userPoolWebClientId: envConfig?.REACT_APP_AWS_AMPLIFY_CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: "awsEndpoint",
        endpoint: envConfig?.REACT_APP_AWS_AMPLIFY_API_GATEWAY_URL,
        region: envConfig?.REACT_APP_AWS_AMPLIFY_API_GATEWAY_REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
};

export const geolabConfig = {
  params: {
    methodName: "GetTownDirect",
    keyTR: envConfig.REACT_APP_GEOLAB_KEY,
    type: 1,
    typeRes: 1,
  },
  geolabEndPointService:
    "https://streetmaster.streetmaster.it/suggest/SuggestServer",
};
